module.exports = __webpack_public_path__ + "static/media/minus.69b30251c6aa797f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/minus.svg
// module id = 1363
// module chunks = 0